import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { MarketplaceLink, RoutesService, SupplierRoutesEnum } from '../shared/services/routes.service';

@Injectable()
export class PendingApprovalGuard {
  constructor(
    @Inject(DOCUMENT) readonly document: Document,
    private _routesService: RoutesService
  ) {}

  get window(): Window {
    return this.document.defaultView;
  }

  canActivate(): Observable<boolean> {
    const isV1RedirectionRequired = this._routesService.isV1RedirectionRequired();
    if (!isV1RedirectionRequired) {
      return of(true);
    }

    return this._routesService.getRoutes([SupplierRoutesEnum.PENDING_APPROVAL]).pipe(
      first(),
      map(([url]: MarketplaceLink[]) => {
        this.window.open(url.drupalHref, '_self');
        return false;
      })
    );
  }

  canActivateChild(): Observable<boolean> {
    return this.canActivate();
  }
}
